import { cn } from '../../lib/cn';
import type { BusinessRuleRow } from '../../automationstudio/framework';

type Props = { rules?: BusinessRuleRow[] };

export function BusinessRuleEnginePanel({ rules = [] }: Props) {
  return (
    <div className="space-y-2">
      {rules.map((r) => (
        <div key={r.name} className="flex items-start justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{r.name}</p>
            <p className="mt-0.5 text-xs text-slate-500">{r.feature}</p>
          </div>
          <div className="shrink-0 text-right">
            <p className={cn(
              'text-lg font-semibold',
              r.priority >= 95 ? 'text-error-600' : r.priority >= 90 ? 'text-warning-600' : 'text-brand-600',
            )}>
              P{r.priority}
            </p>
            <p className="text-xs text-slate-500">{r.active ? 'active' : 'inactive'}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
